import { Vector3 } from 'three';
import * as THREE from 'three/build/three.module';
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min';
import { J3CameraUtils } from './J3CameraUtils';
//import { DeviceOrientationControls } from 'three/examples/jsm/controls/DeviceOrientationControls';
//import { LightProbe } from 'three';
//import { LightProbeGenerator } from 'three/examples/jsm/lights/LightProbeGenerator';
import { MouseAction, EventDetail } from './J3TypeList';
//type ToonType = 'LINEAR'|'QUAD'|'CUBIC'|'QUART'|'QUINT';
//type ToonDir = 'NORMAL'|'REVERSE';


export class J3RenderUtils extends EventTarget {
    // Renderer, Camera関連のユーティリティ
    renderer;
    //raycaster;
    mouse = { x: 0, y: 0 };
    environments = [];
    domes = [];     //ドームオブジェクトの格納配列
    initialIndex = 0;
    //camera;
    controls;
    controlRadius = 0.1;    //OrbitControlの中心からカメラまでの距離
    gyrocontrols;
    initialAutoRotateSpeed;
    markerLocked = false;   //マーカー上にマウスカーソルがある場合 true
    lockedMarker = '';
    tagLocked = false;
    lockedTag = '';

    billboardLocked = false;
    lockedBillboard = '';
    billboard2DLocked = false;
    lockedBillboard2D = '';
    billboard2DLockedIndex:number = 0;

    //ドーム関連
    useDome = false;
    domeRotOffset = [0, 180, 0];
    //MoveTo（カメラ移動メソッド）のパラメータ
    goalPosition = new Vector3(0, 0, 0);    //目標位置
    startPosition = new Vector3(0, 0, 0);   //移動開始時カメラ位置
    targetDistance = 1.0;  //MoveTo（カメラ移動時）の移動距離
    //tweenRatio = 0.01;  //カメラ移動のトゥイーンレシオ
    targetDome: THREE.Mesh = null;  //ターゲットのドーム
    currentDome: THREE.Mesh = null; //現在のドーム
    //useTags = false;
    //tags = [];  //タグオブジェクトの格納配列
    tweens = [];
    isTweening = false;
    duration = 1000;
    easeType = TWEEN.Easing.Quartic.InOut;
    faceToCamera = true;
    //カメラ初期値
    initialCameraPosArray = [0, 0, -10];
    initialCameraLookAt = new Vector3(0, 0, 0);
    filterMarkers = false;  //移動アイコンを距離でスクリーニングするか？

    cameraUtils: J3CameraUtils;
    previousIntersected: string = '';
    previoutIntersectedObject: THREE.Object3D = null;

    prevTime: number;

    // For Future Use
    //this.pmremGenerator = new THREE.PMREMGenerator(this.renderer);
    //this.pmremGenerator.compileEquirectangularShader();

    constructor(public scene, public container: HTMLElement, renderParams) {
        super();

        // レンダラーを作成
        this.renderer = new THREE.WebGLRenderer({
            //canvas: this.targetCanvas,
            antialias: true,
            alpha: true,     //半透明を描画する場合に必要
        });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);

        //レンダラー
        console.log('renderParams', renderParams.sRGB, renderParams.physicallyCorrectLights, renderParams.toneMapping, renderParams.shadowMap);
        //エンコード種類
        if (renderParams.sRGB) {
            this.renderer.outputEncoding = THREE.sRGBEncoding;
        } else {
            this.renderer.outputEncoding = THREE.LinearEncoding;
        }
        //物理ライト
        if (renderParams.physicallyCorrectLights) {
            this.renderer.physicallyCorrectLights = true;
        } else {
            this.renderer.physicallyCorrectLights = false;
        }
        //トーンマッピング
        if (renderParams.toneMapping = 'ACESFilmic') {
            this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
        } else if (renderParams.toneMapping = 'Linear') {
            this.renderer.toneMapping = THREE.LinearToneMapping;
        } else if (renderParams.toneMapping = 'Reinhard') {
            this.renderer.toneMapping = THREE.ReinhardToneMapping;
        } else if (renderParams.toneMapping = 'Cineon') {
            this.renderer.toneMapping = THREE.CineonToneMapping;
        } else {
            this.renderer.toneMapping = THREE.NoToneMapping;
        }
        //シャドウマップ
        if (renderParams.shadowMap) {
            this.renderer.shadowMap.enabled = true;
        } else {
            this.renderer.shadowMap.enabled = false;
        }
        //クリアーカラー
        if (renderParams.clearColor != undefined) {
            const clearColor = new THREE.Color(renderParams.clearColor);
            if (renderParams.clearAlpha != undefined) {
                console.log('clear color', '0x' + renderParams.clearColor.toString(16), 'alpha', renderParams.clearAlpha);
                this.renderer.setClearColor({ color: clearColor, alpha: renderParams.clearAlpha });
                //scene.background = clearColor;
            } else {
                console.log('clear color', '0x' + renderParams.clearColor.toString(16));
                this.renderer.setClearColor({ color: clearColor });
                //scene.background = clearColor;
            }

        } else {
            const clearColor = new THREE.Color(0x999999);
            console.log('default clear color', clearColor);
            //this.renderer.setClearColor({ color: clearColor });
            scene.background = clearColor;
        }


        container.appendChild(this.renderer.domElement);

        // Windowリサイズ処理  
        window.addEventListener('resize', (e: Event) => this.OnWindowResize(e), false);

        //マウス操作
        //this.raycaster = new THREE.Raycaster();
        container.addEventListener('mousemove', (evt) => { this.MouseMoveHandler(evt) });
        container.addEventListener('click', (evt) => { this.MouseClickHandler(evt) });
        //container.addEventListener('mouseenter', (evt) => { this.MouseEnterHandler(evt) });

        this.OnWindowResize();
        this.prevTime = Date.now();
    }

    Render(updateControls = false, updateCameraAnimation = false, useRaycaster = false, pDomes, pTags, pBills, pBill2Ds, topObj: THREE.Object3D) {
        //時刻
        const currentTime = Date.now();
        const deltaTime = (currentTime - this.prevTime) / 1000;  //時間増分(sec)
        //マウス操作（Raycaster）の処理
        //console.log('Render', topObjs.length, topObjs[0].name);
        if (useRaycaster) {
            const markerPrefix = pDomes.marker.prefix;
            const markerSize = pDomes.marker.size;
            const markerSizeFocus = markerSize * pDomes.marker.focusFactor;
            const raycaster = new THREE.Raycaster();
            raycaster.setFromCamera(this.mouse, this.cameraUtils.camera);

            if (this.previoutIntersectedObject != null) {
                if (this.markerLocked) {
                    //this.previoutIntersectedObject.material.opacity = markerOpacity;
                    this.previoutIntersectedObject.scale.set(2 * markerSize, 2 * markerSize, 1);
                }
                else if(this.billboard2DLocked ){
                    const bill2DScale = pBill2Ds[this.billboard2DLockedIndex].tagcommon.scale;
                    this.previoutIntersectedObject.scale.set(bill2DScale[0], bill2DScale[1], bill2DScale[2]);
                }
            }

            //console.log('scene.children', this.scene.children);
            //const intersects = this.raycaster.intersectObjects(this.scene.children, true);  //this.scene.children と記述すること。falseの場合は指定オブジェクトしかチェックしない
            const intersects = raycaster.intersectObjects(topObj.children, true);  //this.scene.children と記述すること。falseの場合は指定オブジェクトしかチェックしない
            this.markerLocked = false;
            this.lockedMarker = '';
            this.tagLocked = false;
            this.lockedTag = '';
            this.billboardLocked = false;
            this.lockedBillboard = '';
            this.billboard2DLocked = false;
            this.lockedBillboard2D = '';


            let intersected: string = '';
            if (intersects.length > 0) {
                //const intersect = intersects[0];       //[0]はもっとも手前のオブジェクトになる
                //for (const intersect of intersects) {
                for (let i = 0; i < 1; i++) {   //実質的にintersect[0]のみ評価している
                    const intersect = intersects[i];   //実質的にintersect[0]のみ評価している
                    const obj = intersect.object;
                    if (obj.name != intersected) {
                        intersected = obj.name;
                        if (intersected != this.previousIntersected) {
                            console.log(intersected);
                            this.previousIntersected = intersected;
                            this.previoutIntersectedObject = obj;
                        }
                    }
                    const prefix = obj.name.split('_')[0];  //接頭語を取り出す
                    if (prefix == markerPrefix) {
                        //360°シーンのマーカーの場合
                        //console.log('on', obj.name, prefix);
                        this.markerLocked = true;
                        this.lockedMarker = obj.name;
                        //console.log('lockedMarker', this.lockedMarker);
                        this.container.style.cursor = 'pointer';
                        //ハイライト
                        obj.scale.set(2 * markerSizeFocus, 2 * markerSizeFocus, 1);
                        break;
                    } else {
                        for (const pTag of pTags) {
                            if (prefix == pTag.prefix) {
                                //タグの場合
                                this.tagLocked = true;
                                this.lockedTag = obj.name;
                                this.container.style.cursor = 'pointer';
                                break;
                            }
                        }
                        if (pBills) {
                            for (const pBill of pBills) {
                                if (prefix == pBill.prefix) {
                                    //ビルボードの場合
                                    this.billboardLocked = true;
                                    this.lockedBillboard = obj.name;
                                    this.container.style.cursor = 'pointer';
                                    break;
                                }
                            }
                        }
                        if (pBill2Ds) {
                            //for (const pBill2D of pBill2Ds) {
                            for (let i = 0; i < pBill2Ds.length; i++){
                                const pBill2D = pBill2Ds[i];
                                if (prefix == pBill2D.prefix) {
                                    //ビルボード2Dの場合
                                    this.billboard2DLockedIndex = 0;
                                    this.billboard2DLocked = true;
                                    this.lockedBillboard2D = obj.name;
                                    this.container.style.cursor = 'pointer';
                                    this.billboard2DLockedIndex = i;
                                    const bill2DScale = pBill2Ds[this.billboard2DLockedIndex].tagcommon.scale;
                                    const bill2DFocusFactor = pBill2Ds[this.billboard2DLockedIndex].tagcommon.focusFactor;
                                    obj.scale.set(bill2DFocusFactor *bill2DScale[0], bill2DFocusFactor *bill2DScale[1], bill2DFocusFactor *bill2DScale[2]);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        //カメラアニメーションのアップデート
        if (updateCameraAnimation) {
            this.cameraUtils.UpdateAnimation(deltaTime);
        }
        //カメラコントローラのアップデート
        if (updateControls) {
            const forced = true;
            //console.log('updateControls', updateControls);
            this.cameraUtils.Update(forced);
        }


        //レンダリングの実行
        this.renderer.render(this.scene, this.cameraUtils.camera);
        this.renderer.renderLists.dispose();
    }

    OnWindowResize(e: Event = null) {
        // ウィンドウ（Canvas）リサイズ時の処理
        // カメラのアスペクト比を変更
        if (this.cameraUtils != null) this.cameraUtils.ResetAspect();
        // Rendererのアスペクト比、サイズを変更
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    MouseMoveHandler(event) {
        const element = event.currentTarget;
        //ウィンドウ中央を(0,0), 右上(1,1)、左下(-1,-1)の相対座標に変換する
        const x = event.clientX - element.offsetLeft;
        const y = event.clientY - element.offsetTop;
        const w = element.offsetWidth;
        const h = element.offsetHeight;
        this.mouse.x = (x / w) * 2 - 1;
        this.mouse.y = -(y / h) * 2 + 1;
        //console.log(mousex, mousey);

    }

    MouseClickHandler(evt) {
        //マーカーロック時(マーカー上にカーソルがある場合)のみ
        //J3ThreeSub でイベントをリスン
        //console.log('MouseClickHandler');
        const action: MouseAction = 'click';
        if (this.markerLocked) {
            //console.log('marker clicked', this.lockedMarker);
            const eventDetail: EventDetail = { detail: { type: 'marker', name: this.lockedMarker } };
            const event = new CustomEvent(action, eventDetail);
            this.dispatchEvent(event);
        } else if (this.tagLocked) {
            //console.log('tag clicked', this.lockedTag);
            const eventDetail: EventDetail = { detail: { type: 'tag', name: this.lockedTag } };
            const event = new CustomEvent(action, eventDetail);
            this.dispatchEvent(event);
        } else if (this.billboardLocked) {
            //console.log('Billboard clicked', this.lockedBillboard);
            const eventDetail: EventDetail = { detail: { type: 'billboard', name: this.lockedBillboard } };
            const event = new CustomEvent(action, eventDetail);
            this.dispatchEvent(event);
        } else if (this.billboard2DLocked) {
            //console.log('Billboard clicked', this.lockedBillboard);
            const eventDetail: EventDetail = { detail: { type: 'billboard2D', name: this.lockedBillboard2D } };
            const event = new CustomEvent(action, eventDetail);
            this.dispatchEvent(event);
        }
    }

    SetEnvironmentMap(imagename: string, useLightprobe = false) {
        // 環境マップの作成
        this.LoadEnvironment(imagename, false, true, useLightprobe);
    }
    SetSkybox(imagename: string, setEnvironmentMap = false, useLightprobe = false) {
        // Skyboxの作成
        this.LoadEnvironment(imagename, true, setEnvironmentMap, useLightprobe);
    }
    LoadEnvironment(imagename: string, setBackground = true, setEnvironmentMap = false, useLightprobe = false) {
        //環境画像のロード。画像名を受けて画像をロードし、environments配列に格納する
        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(imagename, (texture) => {
            //texture.encoding = THREE.sRGBEncoding;
            //texture.offset = [0.5, 0.0];
            texture.mapping = THREE.EquirectangularReflectionMapping;
            this.environments.push(texture);
            if (setBackground) {
                // スカイボックス
                this.scene.background = texture;
            }
            if (setEnvironmentMap) {
                // 環境マップ
                this.scene.environment = texture;
            }
            if (useLightprobe) {
                //LightProbe.copy(LightProbeGenerator.fromCubeTexture(texture) );
            }
        });
    }


    StoreEnvironments(imageArray, initialBackgroundIndex = 0, setEnvironment = false) {
        this.initialIndex = initialBackgroundIndex; //初期背景のインデックス
        //画像名の配列を受けて画像をロードする
        for (const [index, image] of imageArray.entries()) {
            console.log('Environment:', image);
            if (index == initialBackgroundIndex) {
                this.LoadEnvironment(image, true, setEnvironment);
            } else {
                this.LoadEnvironment(image, false, false);
            }
        };
    }

    SelectEnvironment(index = 0) {
        if (index < 0 || index > this.environments.length - 1) {
            console.log('No Environment', index);
            return;
        }
        console.log('SelectEnvironment', index);
        this.scene.background = this.environments[index];
    }
    /*
    SetLightprobe(){
        const lightprobe = new THREE.Lightprobe();
        this.scene.add(lightprobe);
    }*/

    SetAmbientLight(color = 0xffffff, intensity = 1) {
        const ambient = new THREE.AmbientLight(color);
        ambient.intensity = intensity;
        this.scene.add(ambient);
    }

    SetDirectionalLight(color = 0xffffff, intensity = 1, pos = [1, 1, 1], castShadow = false, showHelper = false) {
        const light = new THREE.DirectionalLight(color, intensity);
        light.position.set(pos[0], pos[1], pos[2]);
        light.castShadow = castShadow;
        this.scene.add(light);

        if (showHelper) {
            //ライトのGIZMOを表示
            const helper = new THREE.DirectionalLightHelper(light, 10, 0xFF00FF);
            this.scene.add(helper);
        }
    }

    SetHemisphereLight(skycolor = 0xffffff, goundcolor = 0xffffff, intensity = 1) {
        const light = new THREE.HemisphereLight(skycolor, goundcolor, intensity);
        light.intensity = intensity;
        this.scene.add(light);
    }

    SetPointLight(color = 0xffffff, intensity = 1, distance = 0, pos = [0, 0, 0], showHelper = false) {
        const light = new THREE.PointLight(color, intensity, distance);
        light.position.set(pos[0], pos[1], pos[2]);
        this.scene.add(light);

        if (showHelper) {
            //ライトのGIZMOを表示
            const helper = new THREE.PointLightHelper(light, 10, 0xFFFF00);
            this.scene.add(helper);
        }
    }

    SetSpotLight(color = 0xffffff, intensity = 1, distance = 0, angle = 60.0, exponent = 10, pos = [0, 0, 0], tgt = [0, 0, 0], castShadow = false, showHelper = false) {
        console.log('SetSpotLight', color, intensity, distance, angle, exponent, pos, tgt, castShadow, showHelper);
        const light = new THREE.SpotLight(color, intensity, distance, angle * Math.PI / 180, exponent);
        light.position.set(pos[0], pos[1], pos[2]);
        light.target.position.set(tgt[0], tgt[1], tgt[2]);
        light.castShadow = castShadow;
        this.scene.add(light);

        if (showHelper) {
            //ライトのGIZMOを表示
            const helper = new THREE.SpotLightHelper(light);
            this.scene.add(helper);
        }

    }
    /*
    SetAreaLight(color = 0xffffff, intensity=1, width=1.0, height=1.0, pos =[1,1,1], rot=[0,0,0]){
        const light = new THREE.AreaLight(color, intensity);
        light.width = width;
        light.height = height;
        light.position.set(pos[0],pos[1],pos[2]);
        light.rotation.set(rot[0]*degToRad,rot[1]*degToRad,rot[2]*degToRad);
        this.scene.add(light);
    }
    */

    Dispose(msg: string = '') {
        //console.log('RenderUtils Dispose', msg);
        this.renderer.renderLists.dispose();
    }

}
